import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../views/view.home";

export default function BasicRouting() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}
